import React, { useEffect, createElement } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Dashboard } from './components/Dashboard';
import { LandingPage } from './pages/LandingPage';
import { LoginPage } from './pages/LoginPage';
import { ForecastConceptView } from './components/views/ForecastConceptView';
import { UXDocumentation } from './pages/UXDocumentation';
import { UserPersonas } from './pages/UserPersonas';
import { UserJourneyMap } from './pages/UserJourneyMap';
export function App() {
  useEffect(() => {
    // Microsoft Clarity tracking - with safety checks
    if (typeof window === 'undefined' || typeof document === 'undefined') {
      return;
    }
    // Only load analytics in production
    if (process.env.NODE_ENV !== 'production') {
      return;
    }
    try {
      ;
      (function (c: any, l: any, a: string, r: string, i: string, t: any, y: any) {
        c[a] = c[a] || function () {
          ;
          (c[a].q = c[a].q || []).push(arguments);
        };
        t = l.createElement(r);
        t.async = 1;
        t.src = 'https://www.clarity.ms/tag/' + i;
        y = l.getElementsByTagName(r)[0];
        // Safety check: ensure parent element exists
        if (y && y.parentNode) {
          y.parentNode.insertBefore(t, y);
        } else {
          // Fallback: append to head if no script tags exist
          l.head.appendChild(t);
        }
      })(window, document, 'clarity', 'script', 'v09fnygntk');
    } catch (error) {
      // Silently fail - analytics shouldn't break the app
    }
    // Google Analytics tracking
    try {
      // Load gtag.js script
      const gtagScript = document.createElement('script');
      gtagScript.async = true;
      gtagScript.src = 'https://www.googletagmanager.com/gtag/js?id=G-01C3NX40DC';
      document.head.appendChild(gtagScript);
      (window as any).dataLayer = (window as any).dataLayer || [];
      function gtag(...args: any[]) {
        ;
        (window as any).dataLayer.push(args);
      }
      gtag('js', new Date());
      gtag('config', 'G-01C3NX40DC');
    } catch (error) {
      // Silently fail - analytics shouldn't break the app
    }
  }, []);
  return <BrowserRouter data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/" element={<LandingPage data-id="element-3" />} data-id="element-2" />
        <Route path="/login" element={<LoginPage data-id="element-5" />} data-id="element-4" />
        <Route path="/dashboard" element={<Dashboard data-id="element-7" />} data-id="element-6" />
        <Route path="/forecast/concept" element={<ForecastConceptView data-id="element-9" />} data-id="element-8" />

        {/* UX Documentation Routes */}
        <Route path="/ux" element={<UXDocumentation data-id="element-11" />} data-id="element-10" />
        <Route path="/ux/personas" element={<UserPersonas data-id="element-13" />} data-id="element-12" />
        <Route path="/ux/journey" element={<UserJourneyMap data-id="element-15" />} data-id="element-14" />

        {/* Fallback route */}
        <Route path="*" element={<Navigate to="/" replace data-id="element-17" />} data-id="element-16" />
      </Routes>
    </BrowserRouter>;
}